:host {
  display: block;
}
.qumra-dropdown-container{
  position: relative;
  width: max-content;
  z-index: 10;

}
.qumra-dropdown-container > div {
  cursor: pointer;
  z-index: 10
}
.qumra-dropdown-items-container{
  position: absolute;
  top: 20px;
  left: -12px;
}
.qumra-dropdown-items-container> div{
  position: relative;
  width: max-content;
  height: max-content;
  border-radius: 6px;
  background-color: white;
  border: 1px solid #E0E0E0CC;
  padding: 12px 8px;
}
.qumra-dropdown-items{
   position: absolute;
   display: flex;
   flex-direction: column;
   gap: 8px;
   transform: rotate(45deg);
   background-color: white;
   left: 16px;
   top: -2px;
   width: 20px;
   height: 20px;
   border-left: 1px solid #E0E0E0CC;
   border-top: 1px solid #E0E0E0CC;
   border-top-left-radius: 6px;
}